module.exports = __webpack_public_path__ + "static/media/banking.afe47e1c.png";


//////////////////
// WEBPACK FOOTER
// ./src/home/images/banking.png
// module id = 528
// module chunks = 8